import { SupportedLanguages } from 'src/types/locale'

/**
 * Cache keys for service tracking-related queries and mutations
 */
export const serviceTrackingKeys = {
  all: ['service-tracking'] as const,
  get: (code: string, language: SupportedLanguages) =>
    [...serviceTrackingKeys.all, 'get', code, language] as const,
}
